import React from 'react';
import { generateOptions } from '../../Common/Helpers';

export const FormRow = props => {
    return <div className="row">{props.children}</div>;
};

export const Input = props => {
    return (
        <div className={`formInput ${props.extraClasses}`}>
            <label> {props.label} </label>
            <input
                onChange={props.handler}
                onBlur={props.onblur}
                type={props.inputType}
                placeholder={props.placeholder}
                defaultValue={props.value} />
        </div>
    );
};

export class Select extends React.Component {

    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">
                    <select onChange={this.props.handler} name={this.props.selectname} value={this.props.defaultValue} required>
                        <option disabled="disabled" value="">{this.props.placeholder}</option>
                        {generateOptions(this.props.type, { ...this.props })}
                    </select>
                </div>
            </div>
        );
    }
}

export const MainBtn = props => {
    return (
        <button className={`formMainButton ${props.extraClasses}`} onClick={props.onclick} disabled={props.disabled}>
            {props.title}
        </button>
    );
};

export const CancelBtn = props => {
    return (
        <button className={`formCancelButton ${props.extraClasses}`} onClick={props.onclick}>
            {props.title}
        </button>
    );
};



// WEBPACK FOOTER //
// ./src/customModules/Common/form/formElements.js